module.exports = __webpack_public_path__ + "static/media/APP_MotherTeresa_152x174_6.214a3d4c.png";